import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { setUser, updateExploreMarkerOptions } from 'store/actions';
import {
  Button,
  Popover,
  Switch,
  FormControlLabel,
  TextField,
  Divider,
  IconButton
} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save'
import { sendClientLog } from 'services/logService';

const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 8
  },
  btn: {
    margin: '5px'
  },
  devSettingsBtn: {
    color: 'white', whiteSpace: 'nowrap', 
    [theme.breakpoints.down(389)]: {
      fontSize: '0.6rem',
    }
  }
});

const DevSettingsMenu = ({ classes, user, setUser, markerOptions, updateExploreMarkerOptions }) => {
  const [devSettingsAnchor, setDevSettingsAnchor] = useState(null);
  const [shouldFetchTxnOppsOld, setShouldFetchTxnOppsOld] = useState(localStorage.getItem('txnOppsFetchOld') === 'true');
  const [autoBreakoutThresholdInputLocalValue, setAutoBreakoutThresholdInputLocalValue] = useState(markerOptions.autoBreakoutThreshold ?? '');
  const [inputError, setInputError] = useState(null);
  const showButton = ['local', 'dev', 'test', 'uat'].includes(process.env.REACT_APP_ENV && process.env.REACT_APP_ENV.toLowerCase());

  const toggleDevSettings = (e) => {
    const el = devSettingsAnchor ? null : e.currentTarget;
    setDevSettingsAnchor(el);
  }

  const testLogInfo = () => {
    sendClientLog('Info', 'Test Client Log Info');
  }
  const testLogError = () => {
    sendClientLog('Error', 'Test Client Log Error');
  }

  const handleFetchTxnOppsSwitch = e => {
    localStorage.setItem('txnOppsFetchOld', e.target.checked);
    setShouldFetchTxnOppsOld(e.target.checked);
  }

  const handleExploreMarkerSwitch = (e, option) => {
    updateExploreMarkerOptions({
      [option]: e.target.checked
    })
  }

  const handleInput = e => {
    setAutoBreakoutThresholdInputLocalValue(e.target.value);
    setInputError(e.target.value > 10000 ? 'Cannot exceed 10,000' : null);
  }

  const saveThreshold = () => {
    updateExploreMarkerOptions({
      'autoBreakoutThreshold': parseInt(autoBreakoutThresholdInputLocalValue)
    })
  }

  return (
    showButton &&
    <>
      <Button
        className={classes.devSettingsBtn}
        size='small'
        variant='contained'
        color='secondary'
        onClick={toggleDevSettings}
      >Dev Settings</Button>
      <Popover
        open={Boolean(devSettingsAnchor)}
        anchorEl={devSettingsAnchor}
        onClose={toggleDevSettings}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div className={classes.container}>
          <FormControlLabel
            control={<Switch checked={shouldFetchTxnOppsOld} onChange={handleFetchTxnOppsSwitch} name="txnOppsOld" />}
            label="Fetch txnOpps old"
          />
          <Button onClick={testLogInfo} color='primary' variant='contained' className={classes.btn}>Test Log Info</Button>
          <Button onClick={testLogError} color='primary' variant='contained' className={classes.btn}>Test Log Error</Button>
          <Divider />
          <span style={{ padding: 8 }}><b>Explore marker options</b></span>
          <FormControlLabel
            control={<Switch checked={markerOptions.enableRounding} onChange={e => handleExploreMarkerSwitch(e, 'enableRounding')} name="enableRounding" />}
            label="Enable rounding"
          />
          <span>
            <TextField
              value={autoBreakoutThresholdInputLocalValue}
              onChange={handleInput}
              label="Auto-breakout Threshold"
              error={inputError != null}
              helperText={inputError ?? null}
            />
            <IconButton color="primary" size='small' style={{ marginTop: 18 }} disabled={inputError != null} onClick={saveThreshold}>
              <SaveIcon />
            </IconButton>
          </span>
        </div>
      </Popover>
    </>
  );
}

const mapStateToProps = state => ({
  user: state.appState.user,
  markerOptions: state.exploreMap.markerOptions
});
const mapDispatchToProps = {
  setUser,
  updateExploreMarkerOptions
};

export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(DevSettingsMenu);
